import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { UserAgreementType } from '@flexyoo/api/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-agreement-type-selection',
  templateUrl: './user-agreement-type-selection.component.html',
  styleUrl: './user-agreement-type-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UserAgreementTypeSelectionComponent,
    },
  ],
  imports: [FormsModule, MatRadioModule, TranslateModule],
})
export class UserAgreementTypeSelectionComponent implements ControlValueAccessor {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private onChange: (val: UserAgreementType) => void;
  private onTouched: VoidFunction;

  protected readonly UserAgreementType = UserAgreementType;
  protected selectedOption: UserAgreementType;

  writeValue(val: UserAgreementType): void {
    this.selectedOption = val;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: (val: UserAgreementType) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: VoidFunction): void {
    this.onTouched = fn;
  }

  protected changeSelectedValue(val: UserAgreementType): void {
    this.selectedOption = val;
    this.onChange?.(val);
  }
}
